import React, { useState, useEffect, Fragment, useMemo } from "react";
import Cookie from "js-cookie";
import { Form, Row, Button } from "react-bootstrap";
import * as FieldConstants from "../../../../constants/FieldConstants";
import ErrorContainer from "../../../Common/Errors/ErrorContainer";
import { DELETE_ICON } from "../../../../assets/js/image";
import { otherAddressFields, defaultAddressFields } from "./FormFields";
import "./Address.css";
import {
  renderDuplicateAddressCheckBoxes,
  SimilarAddresses,
  onAddAddress,
  onDeleteAddress,
  handleFieldChange,
  defaultAutoCompleteFieldChange,
  defaultOnSelectAddress,
  handleValidate,
  objectEmpty,
  consturctAddressState,
  validateForm,
} from "./helpers";
import OtherAddresses from "./OtherAddresses";
import { getUserRolePermission } from "../../../../utils/rolePermissionAccess";
import * as Constants from "../../../../constants/Constants";
import * as RolePermissionConstants from "../../../../constants/RolePermissionConstants";
import { useDispatch, useSelector } from "react-redux";
import { httpCreateMultipleAddress } from "../../../../service/httpClient";
import { useHistory } from "react-router";
import { updateServiceData } from "../../../../redux/serviceSlice";

const Address = (props) => {
  const history = useHistory();
  const store = useSelector(({ service }) => service.vendorProfile);
  const dispatch = useDispatch();
  const initialState = {
    ...props,
    ...consturctAddressState(store),
    billingCheckbox: false,
    shippingCheckbox: false,
    rtvCheckbox: false,
    requestErrorMessage: "",
    errors: {},
    validForm: false,
    valuesChanged: false,
    otherAddress: store?.otherAddress || [],
    formDisabled: !(
      RolePermissionConstants.EDIT ===
      getUserRolePermission(
        RolePermissionConstants.VENDORPLATFORM_COMPANYINFORMATION_ADDRESSDETAILS,
        RolePermissionConstants.ALL
      )
    ),
    disableSubmit: false,
  };

  const [formValues, setFormValues] = useState({
    ...initialState,
    prev: initialState,
  });

  const [isMPVendor, setIsMPVendor] = useState(false);
  const pageAccessBasedOnRole =
    getUserRolePermission(
      RolePermissionConstants.VENDORPLATFORM_COMPANYINFORMATION_ADDRESSDETAILS,
      RolePermissionConstants.VMP_PAGEACCESS
    ) === RolePermissionConstants.VIEW;

  const [addressError, setAddressError] = useState({
    addressErrorStatus: false,
    addressErrorMsg: "",
  });

  useEffect(() => {
    setFormValues((state) => ({
      ...state,
      validForm: validateForm(state),
    }));
  }, []);

  useEffect(() => {
    setIsMPVendor(
      props.merchandiseType === Constants.VOB_MERCHANDISE_TYPE_MARKETPLACE
    );

    setFormValues((state) => ({
      ...state,
      formDisabled: !(
        RolePermissionConstants.EDIT ===
        getUserRolePermission(
          RolePermissionConstants.VENDORPLATFORM_COMPANYINFORMATION_ADDRESSDETAILS,
          RolePermissionConstants.ALL
        )
      )
        ? true
        : props.merchandiseType === Constants.VOB_MERCHANDISE_TYPE_MARKETPLACE
        ? true
        : false,
    }));
  }, [props.merchandiseType]);

  const handleSubmit = () => {
    setFormValues((state) => ({ ...state, disableSubmit: true }));
    let state = {
      ...formValues,
      //SVH-2038 add to get current user email to set lastupdatedby field
      userEmail: Cookie.get("email").toLowerCase(),
    };
    let mailAddress = state.mailAddress;
    let billingAddress = state.billingAddress;
    let shippingAddress = state.shippingAddress;
    let rtvAddress = state.rtvAddress;

    let data = [mailAddress, billingAddress, shippingAddress, rtvAddress];

    state.otherAddress &&
      state.otherAddress.forEach((address) => data.push(address));

    let finalAddressArray = addDunsToAddresses(data);
    // Save Addresses
    httpCreateMultipleAddress(finalAddressArray)
      .then((res) => {
        dispatch(updateServiceData({ fetching: true }));
        history.push(`/boarding/vendor/contact/${store?.vendorDetail?.id}`);
      })
      .catch((error) => {
        setFormValues((state) => ({ ...state, disableSubmit: false }));
        setAddressError({
          addressErrorStatus: true,
          addressErrorMsg: error?.response?.data?.message,
        });
        console.log("Error while updating addresses: ", error);
      });
  };

  const addDunsToAddresses = (addressArray) => {
    let finalData = [];
    addressArray.forEach((address) => {
      let newAddressObj = { ...address };
      newAddressObj["duns"] = store?.vendorDetail?.duns;
      //add to get current user email
      newAddressObj["userEmail"] = Cookie.get("email").toLowerCase();
      finalData.push(newAddressObj);
    });
    return finalData;
  };

  const isVendorProfileIdGenerated = useMemo(() => {
    if (store.vendorDetail) {
      if (store.vendorDetail.id) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }, [store]);

  return (
    <fieldset disabled={props.onboardingStatusFlag && !pageAccessBasedOnRole}>
      <>
        {!isVendorProfileIdGenerated && (
          <ErrorContainer
            errorMsg={RolePermissionConstants.VMP_VENDORPROFILEID_NOT_GENERATED}
            errorStatus={true}
            errorStyle="errorMessage"
          />
        )}
        {addressError.addressErrorStatus && (
          <ErrorContainer
            errorMsg={addressError.addressErrorMsg}
            errorStatus={addressError.addressErrorStatus}
            errorStyle="errorMessage"
          />
        )}
        {getUserRolePermission(
          RolePermissionConstants.VENDORPLATFORM_COMPANYINFORMATION_ADDRESSDETAILS,
          RolePermissionConstants.ALL
        ) !== RolePermissionConstants.NONE && (
          <Form className="address-details-container" autoComplete="none">
            {defaultAddressFields().map((address, index) => {
              const addressType = address[0].automationId;
              return (
                <Form.Row key={addressType}>
                  <SimilarAddresses
                    disableFields={
                      formValues.formDisabled || !props.extUserEnabled
                    }
                    handleValidate={handleValidate}
                    errors={formValues.errors}
                    address={address}
                    formValues={formValues}
                    fieldValueObject={formValues[addressType]}
                    setFormValues={setFormValues}
                    onChange={handleFieldChange}
                    onAutoCompleteChange={defaultAutoCompleteFieldChange}
                    onSelectAddress={(selectedAddress, props) =>
                      defaultOnSelectAddress(selectedAddress, props)
                    }
                  />
                  {index === 0 &&
                    !isMPVendor &&
                    renderDuplicateAddressCheckBoxes(
                      formValues.formDisabled || !props.extUserEnabled,
                      formValues,
                      setFormValues,
                      defaultAddressFields()
                    )}
                </Form.Row>
              );
            })}

            {formValues.otherAddress &&
              formValues.otherAddress.map((address, index) => {
                return (
                  <Fragment key={`otherAddress${index}`}>
                    <OtherAddresses
                      handleValidate={handleValidate}
                      errors={formValues.errors}
                      formValues={formValues}
                      setFormValues={setFormValues}
                      otherAddressValues={address}
                      otherAddressFields={otherAddressFields}
                      vendorProfileId={formValues.vendorProfileId}
                      duns={formValues.duns}
                      addressIndex={index}
                      disableFields={
                        formValues.formDisabled || !props.extUserEnabled
                      }
                    />

                    <div
                      className="deleteAnotherAdd deleteAddress"
                      style={{
                        cursor: formValues.formDisabled ? "default" : "pointer",
                        pointerEvents:
                          props.onboardingStatusFlag &&
                          !pageAccessBasedOnRole &&
                          "none",
                        color:
                          props.onboardingStatusFlag &&
                          !pageAccessBasedOnRole &&
                          "grey",
                      }}
                      onClick={(e) =>
                        getUserRolePermission(
                          RolePermissionConstants.VENDORPLATFORM_COMPANYINFORMATION_ADDRESSDETAILS,
                          RolePermissionConstants.VMP_DELETE_ADDRESS
                        ) === RolePermissionConstants.EDIT &&
                        !formValues.formDisabled &&
                        onDeleteAddress(
                          setFormValues,
                          "otherAddress",
                          address,
                          index
                        )
                      }
                    >
                      <DELETE_ICON
                        style="deleteIcon"
                        id={FieldConstants.deleteIconId}
                      ></DELETE_ICON>
                      Delete Address
                    </div>
                  </Fragment>
                );
              })}
            {!isMPVendor &&
              formValues.otherAddress &&
              formValues.otherAddress.length < 3 && (
                <div
                  className="addAddress"
                  style={{
                    cursor: formValues.formDisabled ? "default" : "pointer",
                    pointerEvents:
                      props.onboardingStatusFlag &&
                      !pageAccessBasedOnRole &&
                      "none",
                    color:
                      props.onboardingStatusFlag &&
                      !pageAccessBasedOnRole &&
                      "grey",
                  }}
                  onClick={(e) => {
                    if (!props.extUserEnabled) {
                      return;
                    }
                    getUserRolePermission(
                      RolePermissionConstants.VENDORPLATFORM_COMPANYINFORMATION_ADDRESSDETAILS,
                      RolePermissionConstants.VMP_ADDOTHERADDRESS
                    ) === RolePermissionConstants.EDIT &&
                      !formValues.formDisabled &&
                      onAddAddress(setFormValues, "otherAddress", {
                        vendorProfileId: store?.vendorDetail?.id,
                        duns: store?.vendorDetail?.duns,
                        email: Cookie.get("email").toLowerCase(),
                        category: "Other",
                      });
                  }}
                >
                  + Add Other Address
                </div>
              )}

            <Row className="btn-container">
              <Button
                className="btn cancel-btn"
                onClick={() => {
                  props.setFetchingTrue && props.setFetchingTrue();
                  history.push(
                    `/boarding/vendor/company/${store?.vendorDetail?.id || ""}`
                  );
                }}
                disabled={
                  (formValues.formDisabled && !isMPVendor) || isMPVendor
                }
              >
                CANCEL &amp; RETURN TO PREVIOUS PAGE
              </Button>
              <Button
                className="btn continue-btn"
                onClick={() => handleSubmit()}
                disabled={
                  !isVendorProfileIdGenerated ||
                  !formValues.validForm ||
                  formValues.disableSubmit ||
                  !objectEmpty(formValues.errors) ||
                  formValues.formDisabled ||
                  !props.extUserEnabled
                }
              >
                SAVE &amp; CONTINUE TO NEXT PAGE
              </Button>
            </Row>
          </Form>
        )}
        {getUserRolePermission(
          RolePermissionConstants.VENDORPLATFORM_COMPANYINFORMATION_ADDRESSDETAILS,
          RolePermissionConstants.ALL
        ) === RolePermissionConstants.NONE && (
          <ErrorContainer
            errorMsg={
              RolePermissionConstants.VMP_ADDRESSDETAILS_PAGE_ACCESS_ERROR_MSG
            }
            errorStatus={true}
            errorStyle="errorMessage"
          />
        )}
      </>
    </fieldset>
  );
};

export default Address;
